import React from 'react'

import { PlannerItemResponse } from '@/types/Planner'

type Props = {
  className?: string
  item: PlannerItemResponse
}

const Badge = ({ className = '', item }: Props) => {
  return (
    <div
      className={`w-fit rounded-lg px-4 py-1 text-xs capitalize text-white ${className}`}
      style={{ backgroundColor: item.color }}
    >
      {item?.name || item?.type}
    </div>
  )
}

export default Badge
